export default [
  {
    //訂單異常頁面
    path: "/abnormal",
    name: "Abnormal",
    component: () => import("../views/Native/Abnormal.vue")
  },
  {
    //订单详情页
    path: "/order/:orderStatus/:orderParkingId",
    name: "Order",
    component: () => import("../views/Native/Order.vue")
  },
  {
    //欠费补缴订单列表页面
    path: "/owePayment/:plateNumber",
    name: "OwePayment",
    component: () => import("../views/Native/owePayment")
  },
  {
    //待处理订单
    path: "/pendingOrder/:orderParkingId",
    name: "PendingOrder",
    component: () => import("../views/Native/PendingOrder.vue")
  },
  {
    //付款结果 动态路由参数 orderStatus : 订单状态（14/20） oid : 订单id  orderAmount : 订单金额
    path: "/result/:orderStatus/:oid/:orderAmount",
    name: "Result",
    component: () => import("../views/Native/Result.vue")
  },
  {
    path: "/recovery/:ids",
    name: "Recovery",
    component: () => import("../views/Native/recovery.vue")
  },
  {
    //預付卡頁面
    path: "/advance",
    name: "Advance",
    component: () => import("../views/Native/Advance.vue")
  },
  {
    path: "/unprocessed/:orderunHandleId",
    name: "Unprocessed",
    component: () => import("../views/Native/Unprocessed.vue")
  },
  {
    path: "/orderFlow",
    name: "OrderFlow",
    component: () => import("../views/Native/orderFlow.vue")
  }
];
